import React from 'react'
import PropTypes from 'prop-types';

const Header = (props) => (
    <header id="header" className="alt">
        {/*<Link to="mailto:visitor@hostlund.com?subject=Meet for coffee?" className="icon fa-envelope"><strong>Say hi!</strong></Link>*/}
        <nav>
            <a className="menu-link" onClick={props.onToggleMenu} href="javascript:">Menu</a>
        </nav>
    </header>
)

Header.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Header
